import { withInstall } from '@pit-element-plus/utils'

import LayoutTree from './src/layout-tree.vue'

export const ElLayoutTree = withInstall(LayoutTree)
export default ElLayoutTree

export * from './src/layout-tree'
